
import {Vue, Component, Prop} from 'vue-property-decorator';
import VPreLoader from "@/components/vPreLoader.vue";
import VGenericTable from "@/components/bootstrap/vGenericTable.vue";
import {mapState} from "vuex";
import {round} from "@/utils/Helpers";
import vModal from "@/components/vModal.vue";
import {LocalizationState} from "@/store/modules/LocalizationModule";
import {Recipe} from "@/models/Recipes/Recipe";
import CalculationsRepository from "@/utils/API/CalculationsRepository";
import {ProteinQualityRowDto} from "@/models/Recipes/ProteinQualityRowDto";

@Component({
  components: {vModal, VPreLoader, VGenericTable },
  computed: {
    ...mapState({
      localizationState: (state: any) => state.LocalizationModule
    }),
  },
  methods: {
    round
  }
})
export default class vProteinQualityReport extends Vue {
  localizationState: LocalizationState;
  proteinQualityRows: ProteinQualityRowDto[] = [];
  isLoading : boolean = false;

  @Prop() recipe: Recipe;
  @Prop() showProteinQualityReportModal: boolean;

  get translations() {
    return this.localizationState.translations;
  }

  closeProteinQualityModal() {
    this.$emit("on-cancel");
  }

  getProteinQualityBreakDown() {
    this.isLoading = true;
    CalculationsRepository.getProteinQualityBreakDown(this.recipe.id)
      .then((response) => {
        this.proteinQualityRows = response.data.result;
        this.isLoading = false;
      })
      .catch((error) => {
        if (error.response) {
          this.$snotify.error(
            error.response.data.errorMessages[0].userVisibleMessage
          );
        }
        else this.$snotify.error(this.translations.get("network-error"));
      });
  }

  get downloadUrl() {
    return `${process.env.VUE_APP_BASE_DOMAIN}/api/processes/recipe/reports/GetProteinQualityReportExcel?recipeId=${this.recipe.id}`;
  }
}
